import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Box,
  Typography,
  CardContent,
  CircularProgress,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"; //--> updated on 21-05-2024
//import LoadingButton from "@mui/lab/LoadingButton";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import Modal from "@mui/material/Modal";
import { CardMedia, Card, CardHeader } from "@mui/material";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { grey, red, orange, blue } from "@mui/material/colors";

import ModalUpdateMember from "./ModalUpdateMember";
import { useDispatch, useSelector } from "react-redux";
import {
  delCandAtDueDate,
  addOrUpdateTestResvInfo,
} from "../store/TestReservationSlice";
import { rtafunitarr } from "./GlobalUseData";
import { toast } from "react-toastify";
import moment from "moment";

dayjs.locale("th");
dayjs.extend(buddhistEra);

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "THSarabunNew",
      fontSize: 11,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: grey["100"],
          border: "1px solid blue",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
  },
});

const th_montharr = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];

/*----------------------- TbCheckingBookingData -------------------------------*/
function TbCheckingBookingData(props) {
  /*------------------- added on 19-04-2024 ----------------------------------*/
  const [updatememberlist, setUpdateMemberList] = useState([]);

  /*---------------------- Redux ---------------------------------------------*/
  const dispatch = useDispatch();
  const _updatememberlist = useSelector(
    (state) => state.testresvinfostate.candAtDueDateArr
  );
  const scoringcriteria = useSelector(
    (state) => state.scoringcriteriastate.scoringcriteria
  );

  /*----------------------- Del/Edit Member Info Model -----------------------*/
  const [openEditMbrModal, setOpenEditMbrModal] = useState(false);
  const [openDelMbrModal, setOpenDelMbrModal] = useState(false);
  const handleOpenDelMbrModal = () => setOpenDelMbrModal(true);
  const handleCloseDelMbrModal = () => setOpenDelMbrModal(false);

  /*----------------------- Image ----------------------------------------*/
  const [imgloading, setImgLoading] = useState([]); //---> added : 21-05-2024
  const [openImgPanel, setOpenImgPanel] = useState(false);
  //const handleOpenImgPanel = () => setOpenImgPanel(true);
  const [imagesString, setImagesString] = useState("");
  let imgBlobSrc = null; //------> updated on 04-10-2567

  const [rowid, setRowId] = useState(0); //to get row id of the table (image)
  const [delrowid, setDelRowId] = useState(-1);
  const [editrowinfo, setEditRowInfo] = useState([]);

  const getBase64Image = async (res) => {
    const blob = await res.blob();
    const reader = new FileReader();
    await new Promise((resolve, reject) => {
      reader.onload = resolve;
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    /*****************  added on 04-10-2024 **************************/
    function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    imgBlobSrc = isJsonString(await blob.text())
      ? JSON.parse(await blob.text())
      : await blob.text();
    if (typeof imgBlobSrc !== "string") {
      let tmp = Array(imgloading.length).fill(false);
      setImgLoading(tmp);
      //setImgLoading(false);
    }
    /*--------------------------------------------------------------*/

    return reader.result;
  };
  /*--------------------------------- updated on 17-09-2024 ----------------------------*/
  const handleOpenImgPanel = async (persid, r_id) => {
    //let tmp = [...imgloading]
    let tmp = Array(imgloading.length).fill(false);
    tmp[r_id] = true;
    setImgLoading(tmp);
    //setImgLoading(true); //---> added : 21-05-2024
    //setOpenImgPanel(true);
    const token = localStorage.getItem("token");
    await fetch(
      `${process.env.REACT_APP_API_URL}/pagebookdate/previmgfileformhris/pers_id/${persid}`,
      {
        headers: {
          authtoken: `Bearer ${token}`,
        },
      }
    )
      .then(getBase64Image)
      .then((imgString) => setImagesString(imgString))
      .then(() => {
        //setImgLoading(true);
        setOpenImgPanel(true);
      });
  };
  const handleCloseImgPanel = () => setOpenImgPanel(false);

  /*------------------- Thai Date --------------------------*/
  const thDateFormatFunc = (date) => {
    let thdate = dayjs(date).format("DD-MM-BBBB");
    let thmonth = th_montharr[Number(thdate.split("-")[1]) - 1];
    return thdate.split("-")[0] + " " + thmonth + " " + thdate.split("-")[2];
  };

  /*------------------- Update Only Member -----------------*/
  useEffect(() => {
    const tmpfunc = async () => {
      await Promise.all([_updatememberlist]).then((tmp) => {
        // console.log('tmp_0 : ', tmp[0]);
        setUpdateMemberList(tmp[0]);
        setImgLoading(Array(tmp[0]["member"]?.length).fill(false)); //-----> added on 04-10-2024
      });
    };
    tmpfunc();
  }, [
    setUpdateMemberList,
    props.checkpanelstate,
    updatememberlist["member"],
    _updatememberlist,
  ]);

  //console.log('updatememberlist ---> member --->', updatememberlist, ' : ', _updatememberlist)
  /*--------------------- return ---------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Paper elevation={0} sx={{ padding: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} zeroMinWidth={true}>
            <TableContainer
              style={{ maxWidth: "100%", width: "100%", overflowX: "auto" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={12}
                      sx={{ fontSize: 14, fontWeight: "bold" }}
                    >
                      ตรวจสอบข้อมูล
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={12}
                      sx={{ fontWeight: "bold" }}
                    >
                      รหัสการจอง: {updatememberlist["resvcode"]} วันที่จอง:{" "}
                      {thDateFormatFunc(updatememberlist["date"])}{" "}
                      ช่วงเวลาที่จอง: {updatememberlist["period"]}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={12}
                      sx={{ fontWeight: "bold" }}
                    >
                      {updatememberlist["reason"]} ณ ประเทศ{" "}
                      {updatememberlist["country"]}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      ลำดับ
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      เลขประจำตัวประชาชน
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      ยศ-ชื่อ-นามสกุล
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      ตำแหน่ง
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      สังกัด
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      เหล่า
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      จำพวกทหาร
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      รูปถ่าย
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      อีเมล
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      เบอร์มือถือ
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      เบอร์ที่ทำงาน
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      colSpan={2}
                    >
                      การจัดการ
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {updatememberlist["member"]?.map((mbr, i) => (
                    <TableRow key={i}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell align="center">{mbr.pers_id}</TableCell>
                      <TableCell align="center">
                        {
                          //mbr.rank + ' ' + mbr.name ?? mbr.fname + ' ' + mbr.lname
                          `${mbr?.rank ?? ""} ${
                            mbr?.name ??
                            `${mbr?.fname ?? ""} ${mbr?.lname ?? ""}`
                          }`.trim()
                        }
                      </TableCell>
                      <TableCell align="center">{mbr.position}</TableCell>
                      <TableCell align="center">{mbr.affiliation}</TableCell>
                      <TableCell align="center">{mbr.branch}</TableCell>
                      <TableCell align="center">{mbr.branchgrp}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="ภาพถ่ายของผู้เข้าสอบ">
                          <IconButton
                            sx={{ color: blue["A700"] }}
                            onClick={() => {
                              handleOpenImgPanel(
                                updatememberlist["member"][i].pers_id,
                                i
                              ); //---> updated on 17-09-2024
                              setRowId(i);
                            }}
                          >
                            <ImageIcon />
                            {
                              //*************** updated on 04-10-2024
                              imgloading[i] && (
                                <CircularProgress
                                  size={20}

                                  /*sx={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    marginTop: '-12px',
                                                                    marginLeft: '-12px'
                                                                }}*/
                                />
                              )
                            }
                          </IconButton>
                        </Tooltip>
                        <Modal
                          open={openImgPanel}
                          onClose={handleCloseImgPanel}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Card sx={{ maxWidth: 450 }}>
                            <CardHeader
                              sx={{ textAlign: "center" }}
                              titleTypographyProps={{
                                variant: "caption",
                              }}
                              title={`เลขประจำตัวประชาชน: ${updatememberlist["member"][rowid].pers_id}`}
                              subheaderTypographyProps={{
                                variant: "caption",
                                fontWeight: "bold",
                              }}
                              subheader={`ยศ-ชื่อ-นามสกุล: ${
                                updatememberlist["member"][rowid].name ??
                                updatememberlist["member"][rowid].rank +
                                  " " +
                                  updatememberlist["member"][rowid].fname +
                                  " " +
                                  updatememberlist["member"][rowid].lname
                              }`}
                            />
                            <CardContent>
                              <CardMedia
                                component="img"
                                //src={`${process.env.REACT_APP_API_URL}/pagebookdate/previewfilepath?filepath=${updatememberlist['member'][rowid].image}`}
                                /*src={
                                                                        `${process.env.REACT_APP_API_URL}/pagebookdate/previmgfileformhris/pers_id/${updatememberlist['member'][rowid].pers_id}`
                                                                    }*/
                                src={imagesString}
                                alt={
                                  typeof imgBlobSrc !== "string"
                                    ? "ไม่พบรูปถ่ายของข้าราชการในระบบ HRIS"
                                    : ""
                                } //******************* updated on 04-10-2024
                                height="400"
                                onLoad={() => {
                                  let tmp = [...imgloading];
                                  tmp[rowid] = false;
                                  setImgLoading(tmp);
                                  //setImgLoading(false);
                                }}
                              />
                              {/*
                                                                    imgloading &&
                                                                    <CircularProgress
                                                                        size={50}
                                                                        sx={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            marginTop: '-12px',
                                                                            marginLeft: '-12px'
                                                                        }}
                                                                    />
                                                                */}
                            </CardContent>
                          </Card>
                        </Modal>
                      </TableCell>
                      <TableCell align="center">{mbr.email}</TableCell>
                      <TableCell align="center">{mbr.cellphone}</TableCell>
                      <TableCell align="center">{mbr.offtel}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="แก้ไขข้อมูลผู้เข้าสอบ">
                          <IconButton
                            sx={{ color: orange["400"] }}
                            onClick={() => {
                              setOpenEditMbrModal(true);
                              let editmbrlist = updatememberlist[
                                "member"
                              ].filter(
                                (item) =>
                                  item.pers_id ===
                                  updatememberlist["member"][i].pers_id
                              );
                              //console.log('editmbrlist--->',editmbrlist);

                              setEditRowInfo(editmbrlist);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {
                          /*--------------------------------------------*/
                          /*------------ Link to member page -----------*/
                          /*--------------------------------------------*/
                          openEditMbrModal && (
                            <ModalUpdateMember
                              open={openEditMbrModal}
                              setOpen={setOpenEditMbrModal}
                              editrowinfo={editrowinfo}
                            />
                          )
                        }
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="ลบข้อมูลผู้เข้าสอบ">
                          <IconButton
                            sx={{ color: red["800"] }}
                            onClick={() => {
                              handleOpenDelMbrModal();
                              setDelRowId(i);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        {
                          <Modal
                            open={openDelMbrModal}
                            onClose={handleCloseDelMbrModal}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: 500,
                                bgcolor: "background.paper",
                                border: "2px solid #000",
                                boxShadow: 24,
                                p: 4,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 16,
                                  fontWeight: "bold",
                                }}
                                align="center"
                                component={"div"}
                              >
                                กดปุ่มยืนยัน
                                หากต้องการลบรายชื่อผู้เข้าสอบที่เลือก
                              </Typography>
                              <Typography align="center" component={"div"}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={6}
                                    display={"flex"}
                                    justifyContent={"flex-end"}
                                  >
                                    <Button
                                      variant="contained"
                                      onClick={() => {
                                        let newmbrlist = updatememberlist[
                                          "member"
                                        ].filter(
                                          (item) =>
                                            item.pers_id !==
                                            updatememberlist["member"][delrowid]
                                              .pers_id
                                        );
                                        let newstate = Object.assign(
                                          Object.assign({}, updatememberlist),
                                          { member: newmbrlist }
                                        );
                                        dispatch(delCandAtDueDate(newstate));
                                        props.hidecheckingpanelfunc(
                                          !props.checkpanelstate
                                        );
                                      }}
                                    >
                                      ยืนยัน
                                    </Button>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={6}
                                    display={"flex"}
                                    justifyContent={"flex-start"}
                                  >
                                    <Button
                                      variant="contained"
                                      onClick={handleCloseDelMbrModal}
                                    >
                                      ยกเลิก
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Typography>
                            </Box>
                          </Modal>
                        }
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={6} display={"flex"} justifyContent={"flex-end"}>
            <Button
              variant="contained"
              onClick={() => {
                //อัพเดทรหัสการจอง และข้อมุลในตารางจอง
                let tmp = Object.assign({}, updatememberlist);
                /**************************************************/
                /************* updated on 04-10-2024 **************/
                /**************************************************/
                let sel_scc = scoringcriteria.filter((el) => {
                  return el.mission === tmp["reason"];
                });
                if (sel_scc.length !== 0) {
                  let scc = scoringcriteria.filter((el) => {
                    return el.mission === tmp["reason"];
                  })[0]["scoringcriteriacode"];
                  Object.assign(tmp, { reason: scc });
                  let lastestupdatememberlist = Object.assign(tmp, {
                    testresvdate: moment().format("YYYY-MM-DD"),
                    testresvtime: moment().format("HH:mm"),
                    /*---------------- Have to modify to get from user redux ---------*/
                    coordinator: "1234567890123",
                    /*----------------------------------------------*/
                    testrequnit: Object.keys(rtafunitarr).find(
                      (k) =>
                        rtafunitarr[k] ===
                        updatememberlist["resvcode"].match(/[\D+|\d+]+[\D]/g)[0]
                    ),
                    //'testrequnit': Object.keys(rtafunitarr).find(k => rtafunitarr[k] === updatememberlist['resvcode'].match(/[a-zA-Z]+/g)[0])
                  });

                  //dispatch(addOrUpdateTestResvInfo(lastestupdatememberlist));
                  Promise.all([
                    dispatch(addOrUpdateTestResvInfo(lastestupdatememberlist)),
                  ]).then((res) => {
                    let text = "";
                    switch (res[0].payload.data.status) {
                      case "insert":
                        text = "บันทึกการลงทะเบียนจองการสอบเรียบร้อยแล้ว";
                        break;
                      case "update":
                        text = "อัพเดทการลงทะเบียนจองการสอบเรียบร้อยแล้ว";
                        break;
                      case "error":
                        text =
                          "การลงทะเบียนจองการสอบไม่ประสบความสำเร็จ ตรวจสอบอีกครั้ง";
                        break;
                    }

                    if (res) {
                      toast(text, { position: toast.POSITION.TOP_CENTER });
                      /***** added on 04-10-2024 *******/
                      if (text === "บันทึกการลงทะเบียนจองการสอบเรียบร้อยแล้ว") {
                        props.tabclosefunc(); //func in pagebookdate.jsx
                      }
                    }
                  });
                } else {
                  toast("ท่านยังกรอกข้อมูลไม่ครบถ้วน กรุณาตรวจสอบอีกครั้ง", {
                    position: toast.POSITION.TOP_CENTER,
                  });
                }
              }} //---> end of onClick
            >
              ยืนยันการจองวันทดสอบ
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              onClick={() => {
                props.hidecheckingpanelfunc(!props.checkpanelstate);
              }}
            >
              ย้อนกลับ
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </ThemeProvider>
  );
}

export default TbCheckingBookingData;
